import { useState } from "react";
import { faqs } from "@/mocks/content";

export default function FaqSection() {
  const [open, setOpen] = useState<number>(0);

  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faqs.map((f) => ({
      "@type": "Question",
      name: f.q,
      acceptedAnswer: { "@type": "Answer", text: f.a },
    })),
  };

  return (
    <section id="faq" className="scroll-mt-16">
      <div className="mx-auto max-w-4xl px-4 py-12 md:px-6 md:py-16">
        <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }} />
        <div className="mb-10 text-center">
          <p className="text-xs font-semibold uppercase tracking-widest text-accent-600">FAQ</p>
          <h2 className="font-display mt-2 text-3xl text-foreground-950 md:text-4xl">吃瓜前，先了解这些</h2>
          <p className="mx-auto mt-3 max-w-xl text-sm text-foreground-600">
            关于色瓜网的更新节奏、热度规则与讨论氛围，常见问题都为你整理好了。
          </p>
        </div>

        <div className="space-y-3">
          {faqs.map((f, idx) => {
            const isOpen = open === idx;
            return (
              <div
                key={f.q}
                className={`overflow-hidden rounded-xl border transition-colors ${
                  isOpen ? "border-accent-300 bg-accent-50/50" : "border-background-200 bg-background-100"
                }`}
              >
                <button
                  type="button"
                  onClick={() => setOpen(isOpen ? -1 : idx)}
                  className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left"
                  aria-expanded={isOpen}
                >
                  <h3 className="text-sm font-semibold text-foreground-900 md:text-base">{f.q}</h3>
                  <span
                    className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full transition-colors ${
                      isOpen ? "bg-accent-500 text-background-50" : "bg-background-50 text-foreground-600"
                    }`}
                  >
                    <i className={`${isOpen ? "ri-subtract-line" : "ri-add-line"}`}></i>
                  </span>
                </button>
                {isOpen && (
                  <div className="px-5 pb-5">
                    <p className="text-sm leading-relaxed text-foreground-600">{f.a}</p>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}